import React from "react";
import {
    InputLabel,
    MenuItem,
    Select,
    FormHelperText,
    FormControl,
} from "@material-ui/core";

const primeraLetraMayuscula = (str) => {
    if (!Boolean(str)) {
        return;
    }
    return str.charAt(0).toUpperCase() + str.slice(1);
};

const getNombreLabel = (nombreLabel, name) => {
    if (Boolean(nombreLabel)) {
        return nombreLabel;
    }
    if (Boolean(name)) {
        return primeraLetraMayuscula(name);
    }
};

const getValueFromSelect = (opt) => {
    if (opt && opt.props && opt.props.value) {
        return opt.props.value;
    }
    return false;
};

function SelectField({
    name = "",
    hijosDirectos = [], // array con nombres de hijos directos
    formik,
    nombreLabel = "",
    itemsArray = [],
    multiple = false, // true para que el formik no setee a string vacio y cambie el tipo de dato en selects
    displayEmpty = false,
    showLabel = true,
    fullwidth = "true",
    variant = "outlined",
    ejecutarAccion,
    getValueCustom = getValueFromSelect, // Se puede cambiar por otro al instanciar
    criterioMostrarUnico = true,
    arrayPadreListener = [],
    peticionParaCargarOpcionesAutomatica = false,
    getValueDelArrayPadre = (array) => array[0].value, // Se puede cambiar al instanciar
    reiniciarItemsArray = false,
    variantFormControl = "outlined",
    classNameFormControl = "",
    disabledFormControl = false,
    editar, // Es obligatorio para el componente saber este dato
}) {
    const [estaDeshabilitado, setEstaDeshabilitado] = React.useState(true);

    React.useEffect(() => {
        if(!(editar === false || editar === true)){
            throw "editar debe ser booleano y es obligatorio " +
            "Revisar SelectFieldMaterialUI"
        }
    })

    React.useEffect(() => {
        if (criterioMostrarUnico && itemsArray.length === 1) {
            formik.setFieldValue(name, itemsArray[0].value);
        }
        if (itemsArray.length === 0) {
            setEstaDeshabilitado(true);
        } else {
            setEstaDeshabilitado(false);
        }
    }, [itemsArray]);

    React.useEffect(() => {
        if (
            arrayPadreListener.length === 1 &&
            Boolean(peticionParaCargarOpcionesAutomatica)
        ) {
            const id = getValueDelArrayPadre(arrayPadreListener);
            peticionParaCargarOpcionesAutomatica(id);
        }
        if (Boolean(reiniciarItemsArray) && !editar) {
            reiniciarItemsArray([]);
            formik.setFieldValue(name, "");
        }
    }, [arrayPadreListener]);

    const renderOpciones = (opciones) => {
        if (opciones.length > 0) {
            return opciones.map((item) => {
                return (
                    <MenuItem key={item.value} value={item.value}>
                        {item.label}
                    </MenuItem>
                );
            });
        }
    };

    const defineValue = () => formik.values[name];

    const prioridadDeshabilitarFormControl = () =>
        disabledFormControl ? disabledFormControl : estaDeshabilitado;

    return (
        <>
            <FormControl
                variant={variantFormControl}
                className={classNameFormControl}
                disabled={disabledFormControl}
                error={formik.touched[name] && Boolean(formik.errors[name])}
            >
                {showLabel && (
                    <InputLabel>{getNombreLabel(nombreLabel, name)}</InputLabel>
                )}
                <Select
                    disabled={prioridadDeshabilitarFormControl()}
                    fullwidth={fullwidth}
                    variant={variant}
                    displayEmpty={displayEmpty}
                    label={primeraLetraMayuscula(name)}
                    defaultValue={defineValue()}
                    value={defineValue()}
                    id={name}
                    name={name}
                    onChange={(e, opt) => {
                        formik.handleChange(e);
                        if (Boolean(ejecutarAccion)) {
                            ejecutarAccion(getValueCustom(opt));
                        }
                        if (Boolean(hijosDirectos) && !multiple) {
                            hijosDirectos.forEach((nombreHijo) => {
                                formik.setFieldValue(nombreHijo, "");
                            });
                        }
                    }}
                >
                    {renderOpciones(itemsArray)}
                </Select>
                <FormHelperText>
                    {formik.touched[name] && formik.errors[name]}
                </FormHelperText>
            </FormControl>
        </>
    );
}

export default SelectField;
